export default "https://a.travel-assets.com/partner-portal/doc-anchor-icon.c93c82974e58.svg";